import {Component, Input} from '@angular/core';
import {FormBaseComponent} from '@utils-lib';
import {FormBuilder} from '@angular/forms';
import {DatevMessageService} from '@datev/ngx-ui-components';
import {EntsprichtWohnanschrift} from '@nachdigal';

@Component({
    selector: 'common-ui-entsprichtWohnanschrift',
    templateUrl: './entsprichtWohnanschrift.component.html'
})
export class EntsprichtWohnanschriftComponent extends FormBaseComponent<EntsprichtWohnanschrift> {

    @Input()
    public entsprichtWohnanschriftLabel: string;

    constructor(private readonly formBuilder: FormBuilder,
                protected readonly messageService: DatevMessageService) {
        super(messageService);
    }

    protected createForm(): void {
         this.form = this.formBuilder.group({
            entsprichtWohnanschrift: [this.data?.entsprichtWohnanschrift, []]
        });
    }
}
